































import {Component, Prop, Vue} from 'vue-property-decorator';
import spacetime, {Spacetime} from "spacetime";
import {uniqueId} from "@/util/uniqueId";
import "@/util/dateExtension";

@Component
export default class DateInput extends Vue {
    @Prop({
        default: false
    })
    isRequired!: boolean;

    @Prop({
        default: true
    })
    showRequiredState!: boolean;

    @Prop()
    label!: string;

    @Prop({
        default: null
    })
    tooltip?: string | null;

    @Prop()
    name?: string;

    @Prop()
    error?: string | null;

    private uid = uniqueId();

    @Prop({
        default: null
    })
    value!: Spacetime | null;

    private get hiddenInputValue(): string | null {
        return this.value?.format('iso')?.toString() || null;
    }

    private get dateLocalDate(): Date | null {
        return this.value?.toLocalDate() || null;
    }

    updateValue(newDate: Date) {
        if (newDate) {
            this.$emit('input', spacetime(newDate.toUtcDate(), 'utc'));
        } else {
            this.$emit('input', null);
        }
    }
}
